require('./sentry');
require('./bootstrap');

require('../../vendor/defstudio/laravel-components/resources/js/tools');

require('./contracts/edit');
require('./contracts/contacts');
